/* eslint-disable no-console */
import { select, call } from "redux-saga/effects"
import { path } from "ramda"
import { track, identify, alias, getUserLanguage } from "../utils/analytics"
import { getCurrentPath } from "../redux/startup.redux"

export const AnalyticTypes = {
  IDENTIFY: "ANALYTICS_IDENTIFY",
  TRACK_EVENT: "ANATLYICS_TRACK_EVENT",
  SAVE_APPLICATIONS_SUCCESS: "SAVE_APPLICATIONS_SUCCESS"
}

export const analyticsIdentify = eventPayload => ({
  type: AnalyticTypes.IDENTIFY,
  eventPayload
})

export function* onQuestionViewed({ value }) {
  try {
    const language = getUserLanguage()
    const location = yield select(getCurrentPath)
    yield call(track, value.eventName, {
      ...value,
      location,
      language
    })
  } catch (error) {
    console.error("failed to track application success", error)
  }
}

export function* onQuestionAnswered({ value }) {
  try {
    const language = getUserLanguage()
    const location = yield select(getCurrentPath)
    yield call(track, value.eventName, {
      location,
      ...value,
      language
    })
  } catch (error) {
    console.error("failed to track application success", error)
  }
}

const selectRenewalMortgageWizard = state =>
  path(["form", "renewalMortgageWizard", "values"], state)

export function* onIdentify() {
  try {
    const form = yield select(selectRenewalMortgageWizard)
    const location = yield select(getCurrentPath)

    yield call(alias, form.emailAddress)
    yield call(identify, form.emailAddress, {
      firstName: form.firstName,
      lastName: form.lastName,
      PropertyValue: form.estimatedAmount,
      PropertyType: form.homeType,
      PostalCode: form.postalCode,
      City: form.cityTownVillage,
      Province: form.province,
      Age: form.ageInYears,
      EquityRelease: form.consulted,
      ConsultedType: form.consultedType,
      email: form.emailAddress,
      phone: form.telephoneNumber,
      locale: getUserLanguage(),
      channel: "browser"
    })
    yield call(track, "info submitted", {
      category: "account",
      label: location,
      location,
      language: getUserLanguage()
    })
  } catch (error) {
    console.warn("Error in identify  analytics event: %s", error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/analytics.sagas.js